import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useAddEncumbranceModal } from './context/AddEncumbranceModalContext';

import AddEncumbranceModalHeader from './components/AddEncumbranceModalHeader';
import AddEncumbranceModalBody from './components/AddEncumbranceModalBody';
import AddEncumbranceModalFooter from './components/AddEncumbranceModalFooter';

const AddEncumbranceModal: FC = () => {
  const { data } = useAddEncumbranceModal();

  return (
    <>
      <AddEncumbranceModalHeader />
      <AddEncumbranceModalBody />
      <AddEncumbranceModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default AddEncumbranceModal;
